import { createApiClient } from '@wl/ui';

export const sessionEvents = new EventTarget();

export const api = createApiClient({
  refreshPath: '/platform/auth/refresh',
  onSessionExpired: () => sessionEvents.dispatchEvent(new Event('expired')),
});
